import styled from 'styled-components';

const ContentWrapContainer = styled.div`
  .content-wrap-scrollpane {
    padding: 50px 20px 20px;
  }
`;

export default ContentWrapContainer;
